var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from 'react-dom/client';
import { ROOT_ID } from '@view/constants/root';
import { ImmersiveExperiencePopup } from '../components';
import { isValidCssNumericValue } from '../helpers/types';
import { isValidPosition } from '../molecules/Popup/types';
export const defineOpenImmersiveExperiencePopup = () => {
    window['openImmersiveExperiencePopup'] = (args) => __awaiter(void 0, void 0, void 0, function* () {
        // Wait next tick to ensure any synchronous operations complete first
        yield new Promise((resolve) => setTimeout(resolve, 0));
        if (document.getElementById(ROOT_ID)) {
            throw new Error('Booking Engine Immersive Experience is already open');
        }
        if (!args || !args.propertyCode) {
            throw new Error('Invalid arguments');
        }
        const { closeLabel = 'Close', currency, disableCssTitleReset, height, hideCustomFooter, hideCustomHeader, hidePropertyInfo, lang, onClose, position, propertyCode, width, } = args;
        const wrapper = document.createElement('div');
        document.body.appendChild(wrapper);
        const root = ReactDOM.createRoot(wrapper);
        const handleClose = () => {
            onClose && onClose();
            root.unmount();
            if (wrapper.parentNode) {
                document.body.removeChild(wrapper);
            }
        };
        root.render(_jsx(ImmersiveExperiencePopup, { closeLabel: closeLabel, currency: currency, disableCssTitleReset: disableCssTitleReset, height: isValidCssNumericValue(height) ? height : undefined, hideCustomFooter: !!hideCustomFooter, hideCustomHeader: !!hideCustomHeader, hidePropertyInfo: !!hidePropertyInfo, lang: lang, onClose: handleClose, position: position && isValidPosition(position) ? position : undefined, propertyCode: propertyCode, width: isValidCssNumericValue(width) ? width : undefined }));
    });
};
